define([
    'text!edge/quoteandbind/ho/views/ho-contact-details.html',
    'text!edge/quoteandbind/common/views/prequal-questions.html',
    'text!customerEdge/quoteandbind/common/views/membership.html',
    
    'text!customerEdge/quoteandbind/ho/views/ho-additional-info.html',
    'text!customerEdge/quoteandbind/ho/views/next-steps.html',
    'text!edge/quoteandbind/ho/views/ho-your-home.html',
    'text!edge/quoteandbind/ho/views/ho-construction.html',
    'text!edge/quoteandbind/ho/views/ho-rating.html',
    'text!edge/quoteandbind/ho/views/ho-policy-info.html',

    'edge/quoteandbind/ho/controllers/HOContactDetailsCtrl',
    'edge/quoteandbind/ho/controllers/HOPrequalQuestionsCtrl',
    'customerEdge/quoteandbind/common/controllers/MembershipCtrl',
    'customerEdge/quoteandbind/ho/controllers/HOAdditionalInfoCtrl',
    'customerEdge/quoteandbind/ho/controllers/NextStepsCtrl',
    'edge/quoteandbind/ho/controllers/HOYourHomeCtrl',
    'edge/quoteandbind/ho/controllers/HOConstructionCtrl',
    'edge/quoteandbind/ho/controllers/HORatingCtrl',
    'edge/quoteandbind/ho/controllers/HOPolicyInfoCtrl'

], (HOContactDetailsView, HOPreQualQuestionsView,HOMembershipView, HOAdditionalInfoView, NextStepsView, HOYourHomeView, HOConstructionView, HORatingView, HOPolicyInfoView,
    HOContactDetailsCtrl, HOPreQualQuestionsCtrl, MembershipCtrl, HOAdditionalInfoCtrl, NextStepsCtrl, HOYourHomeCtrl, HOConstructionCtrl, HORatingCtrl, HOPolicyInfoCtrl)=> {
    return ()=> {
    const wizardParentState = 'baseQnbWizard';

return {
    hoContactDetails: {
        parent: wizardParentState,
        template: HOContactDetailsView,
        controller: HOContactDetailsCtrl
    },
    hoPrequalQuestions: {
        parent: wizardParentState,
        template: HOPreQualQuestionsView,
        controller: HOPreQualQuestionsCtrl
    },
    hoMembership: {
        parent: wizardParentState,
        template: HOMembershipView,
        controller: MembershipCtrl
    },
    
    hoAdditionalInfo: {
        parent: wizardParentState,
        template: HOAdditionalInfoView,
        controller: HOAdditionalInfoCtrl
    },

    hoYourHome: {
        parent: wizardParentState,
        template: HOYourHomeView,
        controller: HOYourHomeCtrl
    },
   
    hoConstruction: {
        parent: wizardParentState,
        template: HOConstructionView,
        controller: HOConstructionCtrl
    },
    hoRating: {
        parent: wizardParentState,
        template: HORatingView,
        controller: HORatingCtrl
    },
    /*hoPolicyInfo: {
        parent: wizardParentState,
        template: HOPolicyInfoView,
        controller: HOPolicyInfoCtrl
    },*/
    /*nextSteps: {
        name: 'nextSteps',
        parent: parentState,
        template: NextStepsView,
        controller: NextStepsCtrl
    }*/
};
};
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/ho/config/RouteConfig.js
 **/